




















































import { Component, Vue, Prop } from 'vue-property-decorator'
import ScrollReveal from 'scrollreveal'

@Component
export default class ServiceCard extends Vue {
  @Prop({ default: () => {} })
  serviceInfo!: Object

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  updated () {
    this.initScrollReveal()
  }

  initScrollReveal () {
    ScrollReveal().reveal('.case-content', { interval: 200, duration: 500, distance: '200px', easing: 'cubic-bezier(.39,.54,.63,.99)' })
  }

  jumpLink (url: string) {
    window.open(this.isPrivate ? `#${url}` : url)
  }
}
